/*global ajaxurl */
import Qs from 'qs';
import axios from 'axios';

export default {
  init() {
    // JavaScript to be fired on the single surgeon pages

    // Take the ID from postid-INT in the body tag
    const bodyClassNames = document.body.classList.value;
    const findClassRegex = /[p][o][s][t][i][d]\D\d*/g;
    const findIntRegex = /\d*/g;
    const foundClass = bodyClassNames.match(findClassRegex).toString().match(findIntRegex);
    const surgeonID = parseInt(foundClass[7]);

    /**
     * Get Surgeon Data by post ID
     * @param {String} category 
     */
    function surgeonName(surgeonID) {
      let data = {
        action: 'get_surgeon_ID',
        surgeonID: surgeonID,
      };
      axios
        .post(ajaxurl, Qs.stringify(data))
        .then(function (response) {
          // handle success
          var surgeonName = response.data.data.surgeonName;
          $('div[data-name="select_surgeon"] select').html('<option value="' + surgeonID + '">' + surgeonName + '</option>');
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    }

    if ($('.acf-form').length) {
      surgeonName(surgeonID);
    }


    // 
  },
  finalize() {
    // JavaScript to be fired on the single surgeon pages, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/surgeons.js